module.exports = __webpack_public_path__ + "img/banner-sp-beginer.b541efc.png";